// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"ffc51191","409":"abcfcbc2","453":"f8370b15","581":"acf6643c","647":"f75d527a","649":"f20122eb","869":"2e0e0011"}[chunkId] + ".chunk.js";
};